export default "__VITE_ASSET__Cbnxo1dL__"